let API_BASE_URL: string;

if (process.env.REACT_APP_API_BASE_URL) {
    // Force un backend precis au build (utilise pour le prerendering, qui sert
    // le build sur localhost et ne doit pas retomber sur le Django local).
    API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
} else {
    const hostname = window.location.hostname;

    if (hostname === 'localhost' ||
        hostname === '127.0.0.1' ||
        hostname.startsWith('192.168.') ||
        hostname.startsWith('10.') ||
        hostname.startsWith('172.16.')
    ) {
        API_BASE_URL = 'http://localhost:8000/api/';
    } else {
        API_BASE_URL = 'https://admin.djmayday.com/api/';
    }
}

export default API_BASE_URL